import { useEffect, useState } from "react";
import { ILogin } from "../../../types/types";
import { useNavigate } from "react-router-dom";
import { authApi } from "../services/authServices";
export const useAuth = () => {
  const [error, setError] = useState<string>("");
  const [isValidSession, setIsValidSession] = useState<boolean | null>(null);
  const navigate = useNavigate();

  const navigateHome = () => {
    void navigate("/admin/matches");
  };

  useEffect(() => {
    const checkSession = async () => {
      const validSession = await authApi.verifySession();
      setIsValidSession(validSession);
    };
    void checkSession();
  }, []);

  useEffect(() => {
    if (isValidSession) {
      navigateHome();
    }
  }, [isValidSession]);

  const requestAuth = async (payload: ILogin) => {
    setError("");

    const errorMessage = await authApi.login(payload);

    if (errorMessage) {
      setError(errorMessage);
    } else {
      setIsValidSession(true);
      navigateHome();
    }
  };
  return { requestAuth, error, setError };
};
